import React from 'react';
import StyledWrapper from './style';
import Container from '@/Components/atoms/Container';
import { useGetProductsServerValues } from '../../Hooks/useGetServerValues';
import SellerAvatarSvg from '@/Components/atoms/CommonSvg/sellerAvatarSvg';
import ProductList from '@/Components/moleculas/ProductList';
import { RequestStatus } from '@/Services/Axios';
import { useTranslation } from 'next-i18next';
import { LIST_GRID_TYPE } from '@/Types/CommonTypes';
import BaseButton from '@/Components/atoms/BaseComponents/BaseButton';
import PhoneSvg from '@/Components/atoms/CommonSvg/phone';
import { DateService } from '@/Services/DateService';

type Props = {};

const Main = (props: Props) => {
  const { t } = useTranslation();
  const userinfo = useGetProductsServerValues(state => state.state.userinfo)!;
  const data = useGetProductsServerValues(state => state.state.data)!;

  return (
    <StyledWrapper>
      <Container>
        <div className='wrapper'>
          <div className='user-info'>
            <div className='top'>
              <SellerAvatarSvg />
              <h3>{userinfo.firstname + ' ' + userinfo.lastname}</h3>
              <p>{t('product_page.sign-in', { key: DateService.toDDMMYYYY(userinfo.createdAt) })}</p>
            </div>

            {/* <div className='btns'>
              <BaseButton onClick={onSeePhoneNumber} className='btn-call' href={isVisiblePhone ? `tel:${product.phone}` : ''}>
                <PhoneSvg />
                {isVisiblePhone ? product.phone : t('call')}
              </BaseButton>
            </div> */}
          </div>
          <div className='user-products'>
            <div className='top'>
              <h3 className='title'>{t('user_announcements')}</h3> <span>: {data?.length} </span>
            </div>
            <ProductList gridType={LIST_GRID_TYPE.GRID} data={data} loading={false} />
          </div>
        </div>
      </Container>
    </StyledWrapper>
  );
};

export default Main;
